import { render, staticRenderFns } from "./FeedModal.vue?vue&type=template&id=3dbcf85e&scoped=true&"
import script from "./FeedModal.vue?vue&type=script&lang=js&"
export * from "./FeedModal.vue?vue&type=script&lang=js&"
import style0 from "./FeedModal.vue?vue&type=style&index=0&id=3dbcf85e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbcf85e",
  null
  
)

export default component.exports